"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledArgs = exports.DelayedMessageArgs = exports.DelayedArgs = exports.WithNotchColorArgs = exports.IlDefaultCardArgs = void 0;
var enums_1 = require("../../shared/enums");
exports.IlDefaultCardArgs = {
    subjectIcon: enums_1.CustomIconTypeEnum.CALVERT_ELECTIVE,
    onClick: undefined,
    title: 'Office Applications I: Tutorials for Microsoft® Word®, PowerPoint®, and Publisher® (2013)',
};
exports.WithNotchColorArgs = {
    notchColor: 'error.main',
    subjectIcon: enums_1.CustomIconTypeEnum.CALVERT_ELECTIVE,
    title: 'Office Applications I: Tutorials for Microsoft® Word®, PowerPoint®, and Publisher® (2013)',
    status: 'On time',
    progressPercent: 50,
    showProgress: true,
};
exports.DelayedArgs = {
    notchColor: 'error.main',
    subjectIcon: enums_1.CustomIconTypeEnum.CALVERT_ELECTIVE,
    title: 'Office Applications I: Tutorials for Microsoft® Word®, PowerPoint®, and Publisher® (2013)',
    delayed: true,
    status: 'Behind',
    showProgress: true,
    progressPercent: 50,
    delayPercent: 15,
    letterGrade: 'B',
};
exports.DelayedMessageArgs = __assign(__assign({}, exports.DelayedArgs), { progressMessage: '1 Overdue Assignment', progressMessageSx: {
        '& p': {
            color: 'error.main',
            fontWeight: 600,
        },
    } });
exports.DisabledArgs = {
    title: 'Fundamentals of Programming and Software Development',
    message: 'Begins Monday Sept. 8th',
    subjectIcon: enums_1.CustomIconTypeEnum.CALVERT_ELECTIVE,
    notchColor: 'action.disabled',
    iconColor: 'action.disabled',
    sx: {
        color: 'action.disabled',
    },
};
